import COLORS from "../../config/colors";
import Icons from "../Icons";

export default function CreateInvoiceModal({
  show, onClose, onCreate, creating,
  invoiceForm, setInvoiceForm,
  invoiceForCustomer, liveInvoices,
  styles,
}) {
  if (!show) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: COLORS.white, borderRadius: 16, padding: 32, width: 520, maxHeight: "80vh", overflowY: "auto", boxShadow: "0 12px 40px rgba(0,0,0,0.15)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 style={styles.sectionTitle}>Create Invoice</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: COLORS.stone }}><Icons.X /></button>
        </div>

        {/* Balance summary when creating from CRM */}
        {invoiceForCustomer && invoiceForCustomer.estimate > 0 && (() => {
          const est = invoiceForCustomer.estimate;
          const alreadyInvoiced = liveInvoices
            .filter(i => (i.customer_name === invoiceForCustomer.name) && i.status !== "cancelled")
            .reduce((s, i) => s + Number(i.total || 0), 0);
          const paid = invoiceForCustomer.paid || 0;
          const remaining = est - alreadyInvoiced;
          return (
            <div style={{ padding: 16, background: COLORS.cream, borderRadius: 10, marginBottom: 16 }}>
              <div style={styles.label}>Account Summary</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8, marginTop: 8 }}>
                <div><div style={{ fontSize: 11, color: COLORS.stone }}>Estimate</div><div style={{ fontSize: 16, fontWeight: 700, color: COLORS.bark }}>${est.toLocaleString()}</div></div>
                <div><div style={{ fontSize: 11, color: COLORS.stone }}>Invoiced</div><div style={{ fontSize: 16, fontWeight: 700, color: COLORS.honey }}>${alreadyInvoiced.toLocaleString()}</div></div>
                <div><div style={{ fontSize: 11, color: COLORS.stone }}>Paid</div><div style={{ fontSize: 16, fontWeight: 700, color: COLORS.green }}>${paid.toLocaleString()}</div></div>
                <div><div style={{ fontSize: 11, color: COLORS.stone }}>Remaining</div><div style={{ fontSize: 16, fontWeight: 700, color: remaining > 0 ? COLORS.red : COLORS.green }}>${remaining.toLocaleString()}</div></div>
              </div>
            </div>
          );
        })()}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div>
            <label style={styles.label}>Customer Name</label>
            <input value={invoiceForm.customerName} onChange={e => setInvoiceForm(f => ({ ...f, customerName: e.target.value }))} style={styles.input} placeholder="Sarah Mitchell" />
          </div>
          <div>
            <label style={styles.label}>Customer Email</label>
            <input value={invoiceForm.customerEmail} onChange={e => setInvoiceForm(f => ({ ...f, customerEmail: e.target.value }))} style={styles.input} placeholder="sarah@email.com" />
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>Address</label>
          <input value={invoiceForm.customerAddress} onChange={e => setInvoiceForm(f => ({ ...f, customerAddress: e.target.value }))} style={styles.input} placeholder="123 Pine St, Truckee, CA" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>Description</label>
          <input value={invoiceForm.description} onChange={e => setInvoiceForm(f => ({ ...f, description: e.target.value }))} style={styles.input} placeholder="16.5% deposit — Deck Replacement" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>Due Date</label>
          <input type="date" value={invoiceForm.dueDate} onChange={e => setInvoiceForm(f => ({ ...f, dueDate: e.target.value }))} style={styles.input} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={styles.label}>Line Items</label>
          {invoiceForm.lineItems.map((item, i) => (
            <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <input
                value={item.description} placeholder="Description"
                onChange={e => { const items = [...invoiceForm.lineItems]; items[i] = { ...items[i], description: e.target.value }; setInvoiceForm(f => ({ ...f, lineItems: items })); }}
                style={{ ...styles.input, flex: 2 }}
              />
              <input
                value={item.amount} placeholder="Amount" type="number"
                onChange={e => { const items = [...invoiceForm.lineItems]; items[i] = { ...items[i], amount: e.target.value }; setInvoiceForm(f => ({ ...f, lineItems: items })); }}
                style={{ ...styles.input, flex: 1 }}
              />
              {invoiceForm.lineItems.length > 1 && (
                <button onClick={() => setInvoiceForm(f => ({ ...f, lineItems: f.lineItems.filter((_, j) => j !== i) }))} style={{ background: "none", border: "none", cursor: "pointer", color: COLORS.red, fontSize: 16 }}>&times;</button>
              )}
            </div>
          ))}
          <button onClick={() => setInvoiceForm(f => ({ ...f, lineItems: [...f.lineItems, { description: '', amount: '' }] }))} style={{ background: "none", border: `1px dashed ${COLORS.honey}`, borderRadius: 8, padding: "8px 16px", color: COLORS.honey, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", width: "100%" }}>
            + Add Line Item
          </button>
        </div>

        <div style={{ padding: 12, background: COLORS.cream, borderRadius: 10, marginBottom: 16, display: "flex", justifyContent: "space-between", fontSize: 16 }}>
          <span style={{ fontWeight: 600 }}>Total:</span>
          <span style={{ fontWeight: 700, color: COLORS.bark }}>${invoiceForm.lineItems.reduce((s, l) => s + Number(l.amount || 0), 0).toLocaleString()}</span>
        </div>

        <button onClick={onCreate} disabled={creating || !invoiceForm.customerName} style={{ ...styles.primaryBtn, width: "100%", opacity: creating || !invoiceForm.customerName ? 0.6 : 1 }}>
          {creating ? "Creating..." : "Create Invoice"}
        </button>
      </div>
    </div>
  );
}
